// LanguageContext.js
import React, { createContext, useState, useEffect } from "react";
import { useParams } from "@tanstack/react-router";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const params = useParams({ strict: false });
  const lang = params?.lang;
  const [language, setLanguage] = useState(lang || "es");

  useEffect(() => {
    if (lang && lang !== language) {
      setLanguage(lang);
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
